module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_16_1.cdb030bb.jpeg";